export default "__VITE_ASSET__C0SYn9bp__"